/**************************************************************************************************/
/*   File: /src/app/shared/components/ambito-selector/ambito.selector.ts                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

import * as fromModels from '../../models';

/**
 * The plan selector
 */
@Component({
    selector: 'nwpl-frnt-ambito-selector',
    templateUrl: './ambito.selector.html',
    styleUrls: ['./ambito.selector.scss']
})
export class AmbitoSelectorComponent implements OnChanges {

    /**
     * The filtere ambiti array
     */
    @Input() filteredAmbiti: fromModels.Ambito[] = [];
    /**
     * The ambiti types array
     */
    @Input() ambiti: fromModels.Ambito[] = [];
    /**
     * The selected plan type
     */
    @Input() selectedAmbiti: string[] = [];
    /**
     * The selected plan type
     */
    @Input() selectedPlan: string;
    /**
     * The is validating
     */
    @Input() isValidating: boolean;
    /**
     * The is validated flag
     */
    @Input() isValidated: boolean;
    /**
     * The show strategy
     */
    @Input() showStrategy: 'disable' | 'hide' = 'disable';
    /**
     * The selected event emitter
     */
    @Output() selected: EventEmitter<string> = new EventEmitter<string>();
    /**
     * The removed event emitter
     */
    @Output() removed: EventEmitter<string> = new EventEmitter<string>();

    /**
     * The constructor
     */
    constructor() { }

    /**
     * The ng on changes hook
     * @param changes The changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedAmbiti || changes.ambiti) {            
            this.filterAmbiti(this.ambiti);
        }
    }

    /**
     * Select ambito
     * @param value the ambito selected value
     */
    selectAmbito(value: string) {
        this.selected.emit(value !== 'undefined' ? value : undefined);
    }

    /**
     * On remove ambito
     * @param value The ambito code
     */
    onRemoveAmbito(value: string) {
        this.removed.emit(value !== 'undefined' ? value : undefined);
    }

    /**
     * Filter ambiti 
     */
    /* istanbul ignore next */
    private filterAmbiti(newAmbiti: fromModels.Ambito[]) {
        if (!newAmbiti || newAmbiti.length === 0 || !Array.isArray(newAmbiti)) {
            this.filteredAmbiti = [];
        } else {
            this.filteredAmbiti = newAmbiti.filter((x: fromModels.Ambito) => {

                if (this.selectedAmbiti === undefined || this.selectedAmbiti === null) {
                    return x.value;
                } else {
                    return this.selectedAmbiti.indexOf(x.value) < 0;
                }
            });
        }
    }

}
